import VueSubmit from './component/VueSubmit.vue'
import Plugin from './plugin/VueSubmit.js'

export default VueSubmit
export { Plugin }
